import { USER_UPDATE, USER_UNSET } from '@/store/actions/user/action-typs';
import { getObjectInLS } from '@/util/localstorage';

const user = getObjectInLS('user');

const initialState = Object.assign({}, {
  id: user ? user.id : null,
  account: user ? user.account : null,
  token: user ? user.token : null,
  permission: null
});

const reducer = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case USER_UPDATE:
      return updateUser(state, payload);
    case USER_UNSET:
      return unsetUser(state);
    default:
      return state;
  }
};

function updateUser(state, payload) {
  return {
    ...state,
    ...payload
  };
}

function unsetUser(state) {
  return {};
}

export default reducer;
